import { SxStyle } from '../../types/style';

const contentPaper: SxStyle = {
    width: '100%',
    height: '196px',
    backgroundColor: '#0097DA1A',
    borderRadius: '16px',
    padding: '16px'
};

const contentPaperStack: SxStyle = {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
};

const contentPaperStackBox: SxStyle = {
    width: '48px',
    height: '48px',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const contentPaperStackBox2Typography: SxStyle = {
    fontWeight: 600
};

const contentPaperStackButton: SxStyle = {
    fontWeight: 600
};

const thumbsContainer: SxStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: '16px'
};

const thumb: SxStyle = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    // marginBottom: 8,
    // marginRight: 8,
    width: 100,
    height: 100,
    padding: "4px",
    boxSizing: 'border-box'
};

const thumbInner: SxStyle = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img: SxStyle = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

export const fileUploadStyle = {
    contentPaper,
    contentPaperStack,
    contentPaperStackBox,
    contentPaperStackBox2Typography,
    contentPaperStackButton,
    thumbsContainer,
    thumb,
    thumbInner,
    img
};